/**
 * Pure decision for FlintGridWrapper's opt-in empty state.
 *
 * Kept in its own dependency-free module so the guard rules are unit-testable
 * without dragging the whole FlintGridWrapper component graph (Kendo Grid +
 * react-router-dom) into the test runner.
 *
 * Show the placeholder only when the consumer opted in, a load has finished,
 * it isn't loading, and there are zero rows — never before the first load
 * (`loadCompleted`) and never after a failed load (`loadCompleted` is set on
 * success only).
 */
export function shouldShowEmptyState(args: {
    hasEmptyState: boolean;
    isLoading: boolean;
    rowCount: number;
    loadCompleted: boolean;
}): boolean {
    return args.hasEmptyState && !args.isLoading && args.rowCount === 0 && args.loadCompleted;
}
